import { render, staticRenderFns } from "./OptionsCarousel.vue?vue&type=template&id=51127ef1"
import script from "./OptionsCarousel.vue?vue&type=script&lang=js"
export * from "./OptionsCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports